import { useSelector } from 'react-redux';
import { LicenseInfo } from '@mui/x-license';
import { ThemeProvider } from '@mui/material/styles';
import { BrowserRouter } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import themes from 'themes';
import Router from 'routes';

const App = () => {
    const customization = useSelector((state) => state.customization);
    LicenseInfo.setLicenseKey(
        'bc6312a3e13892b5b45120ccfbf199cbTz0xMTkxODEsRT0xNzkxNTAzOTk5MDAwLFM9cHJvLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI='
    );

    return (
        <ThemeProvider theme={themes(customization)}>
            <BrowserRouter>
                <Router />
                <ToastContainer />
            </BrowserRouter>
        </ThemeProvider>
    );
};

export default App;
